var _path, _path2, _rect, _path3, _g, _g2, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingsUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_1_",
    "data-name": "calendar (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.198,
    height: 72.198,
    viewBox: "0 0 72.198 72.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54435",
    "data-name": "Path 54435",
    d: "M72.2,125.23v50.905H0V125.23L4.371,121H67.8Z",
    transform: "translate(0 -103.938)",
    fill: "#deecf1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54436",
    "data-name": "Path 54436",
    d: "M292.1,125.23v50.905H256V121h31.7Z",
    transform: "translate(-219.901 -103.938)",
    fill: "#c6e2e7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3251",
    "data-name": "Rectangle 3251",
    width: 72.198,
    height: 16.409,
    transform: "translate(0 4.923)",
    fill: "#64b5f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54437",
    "data-name": "Path 54437",
    d: "M216.153,368.46l-7.826,7.868-2.115,2.115-5.711-5.753,2.961-2.961,2.75,2.707,2.115-2.115,4.865-4.823Z",
    transform: "translate(-172.228 -313.959)",
    fill: "#00abe9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47261",
    "data-name": "Group 47261",
    transform: "translate(8.602 29.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54438",
    "data-name": "Path 54438",
    d: "M73.691,223.691H61V211H73.691Z",
    transform: "translate(-61 -211)",
    fill: "#a8d3d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54439",
    "data-name": "Path 54439",
    d: "M211,211v12.691h12.691V211Z",
    transform: "translate(-189.848 -211)",
    fill: "#a8d3d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54440",
    "data-name": "Path 54440",
    d: "M73.691,373.691H61V361H73.691Z",
    transform: "translate(-61 -339.848)",
    fill: "#a8d3d8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47262",
    "data-name": "Group 47262",
    transform: "translate(36.099 29.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54441",
    "data-name": "Path 54441",
    d: "M374.691,223.691H362V211h12.691Z",
    transform: "translate(-347.053 -210.782)",
    fill: "#8ebac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54442",
    "data-name": "Path 54442",
    d: "M374.691,373.691H362V361h12.691Z",
    transform: "translate(-347.053 -339.63)",
    fill: "#8ebac5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3252",
    "data-name": "Rectangle 3252",
    width: 6.563,
    height: 13.127,
    transform: "translate(0 0)",
    fill: "#8ebac5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54443",
    "data-name": "Path 54443",
    d: "M260.865,365.5l2.961,2.961L256,376.329v-6.007Z",
    transform: "translate(-219.901 -313.959)",
    fill: "#0095ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 36.099,
    height: 16.409,
    transform: "translate(36.099 4.923)",
    fill: "#64b5f6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 9.845,
    height: 13.127,
    transform: "translate(31.177)",
    fill: "#00465f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3255",
    "data-name": "Rectangle 3255",
    width: 4.923,
    height: 13.127,
    transform: "translate(36.099)",
    fill: "#002c3c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3256",
    "data-name": "Rectangle 3256",
    width: 8.204,
    height: 13.127,
    transform: "translate(11.486)",
    fill: "#00465f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 4.923,
    height: 13.127,
    transform: "translate(14.768)",
    fill: "#002c3c"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3258",
    "data-name": "Rectangle 3258",
    width: 9.845,
    height: 13.127,
    transform: "translate(52.508)",
    fill: "#00465f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    width: 4.923,
    height: 13.127,
    transform: "translate(57.43)",
    fill: "#002c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsUpcoming);
export default __webpack_public_path__ + "static/media/meetings-upcoming.1ddc2723532df0d9063b020c2b1e9f51.svg";
export { ForwardRef as ReactComponent };